<template>
    <BaseButton
        v-if="!isEditing"
        :size="SizeAll.Tiny"
        data-spec-class="button-group-edit__edit"
        @click="emits('edit')"
    >
        {{ t('actions.edit') }}
    </BaseButton>

    <BaseButton
        v-if="isEditing"
        :size="SizeAll.Tiny"
        :is-loading="isUpdating"
        class="mr-1"
        data-spec-class="button-group-edit__save"
        @click.prevent="emits('update')"
    >
        {{ t('actions.save') }}
    </BaseButton>

    <BaseButton
        v-if="isEditing"
        :size="SizeAll.Tiny"
        :theme="Theme.Secondary"
        data-spec-class="button-group-edit__cancel"
        @click="emits('cancel')"
    >
        {{ t('actions.cancel') }}
    </BaseButton>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue';
import { SizeAll, Theme } from '@/types';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const emits = defineEmits(['edit', 'update', 'cancel']);

defineProps<{
    isEditing: boolean;
    isUpdating: boolean;
}>();
</script>
